export const CAIXAS_STYLES = `
  :root:has(.caixas-shell) {
    --caixas-dialog-surface: #fff;
    --caixas-dialog-border: #dee7e8;
    --caixas-dialog-ink: #183f3b;
    --caixas-dialog-muted: #647b7c;
    --caixas-primary: #a0eb70;
    background: #fff;
  }
  :root[data-theme='dark']:has(.caixas-shell) {
    --caixas-dialog-surface: #202122;
    --caixas-dialog-border: #303332;
    --caixas-dialog-ink: #f2f0eb;
    --caixas-dialog-muted: #a6a9af;
    --caixas-primary: #8db47a;
    background: #0e0f10;
  }
  :root:has(.caixas-shell) body { background: inherit; }
  .app-shell-main:has(.caixas-shell) { background: #fff; }
  :root[data-theme='dark'] .app-shell-main:has(.caixas-shell) { background: #0e0f10; }
  .caixas-shell {
    --app-page-gutter: clamp(24px, 5vw, 72px);
    --login-bg: #fff;
    --login-surface: #fff;
    --login-text: #183f3b;
    --login-muted: #647b7c;
    --login-border: #dee7e8;
    --login-accent: #1d704b;
    width: 100%;
    max-width: calc(1120px + 2 * var(--app-page-gutter));
    min-width: 0;
    margin: 0 auto;
    padding: 32px var(--app-page-gutter) 72px;
    box-sizing: border-box;
    overflow-x: clip;
  }
  :root[data-theme='dark'] .caixas-shell {
    --login-bg: #0e0f10;
    --login-surface: #202122;
    --login-text: #f2f0eb;
    --login-muted: #a6a9af;
    --login-border: #303332;
    --login-accent: #8db47a;
  }
  .caixas-page-stage {
    min-width: 0;
    animation: operational-surface-enter var(--operational-motion-surface) var(--operational-ease-out) both;
    transition: opacity var(--operational-motion-update) var(--operational-ease-out), transform var(--operational-motion-update) var(--operational-ease-out);
  }
  .caixas-visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .caixas-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin: 1rem 0 1.15rem;
  }
  .caixas-page-header > div:first-child { min-width: 0; }
  .caixas-page-header-icon {
    width: 2.5rem;
    height: 2.5rem;
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    border-radius: 10px;
    color: var(--login-accent);
    background: color-mix(in srgb, var(--login-accent) 9%, transparent);
  }
  .caixas-page-header h1 {
    margin: 0;
    color: var(--login-text);
    font: 700 1.9rem/1 'Barlow Condensed', sans-serif;
    letter-spacing: .04em;
  }
  .caixas-page-header-action { display: flex; align-items: center; }
  .caixas-pill-button,
  .caixas-table-action,
  .caixas-back-button {
    min-height: 2.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: .45rem;
    padding: 0 .9rem;
    border: 1px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    font: 700 .84rem 'DM Sans', sans-serif;
    transition: background var(--operational-motion-hover) ease, border-color var(--operational-motion-hover) ease, color var(--operational-motion-hover) ease, transform var(--operational-motion-hover) ease, filter var(--operational-motion-hover) ease;
  }
  .caixas-pill-button:focus-visible,
  .caixas-table-action:focus-visible,
  .caixas-back-button:focus-visible,
  .caixas-supplier-card:focus-visible,
  .caixas-observation-toggle:focus-visible {
    outline: 2px solid var(--login-accent);
    outline-offset: 2px;
  }
  .caixas-pill-button:disabled { cursor: not-allowed; opacity: .55; }
  .caixas-pill-button-primary { color: #183f3b; background: var(--caixas-primary); }
  .caixas-pill-button-primary:hover:not(:disabled) { filter: brightness(1.04); }
  .caixas-pill-button-secondary:hover:not(:disabled),
  .caixas-back-button:hover:not(:disabled),
  .caixas-icon-button:hover:not(:disabled) {
    background: color-mix(in srgb, var(--login-muted) 8%, var(--login-surface));
  }
  .caixas-pill-button:active:not(:disabled),
  .caixas-table-action:active:not(:disabled),
  .caixas-back-button:active:not(:disabled) { transform: scale(.98); }
  .caixas-pill-button-secondary,
  .caixas-back-button {
    color: var(--login-text) !important;
    border-color: var(--login-border);
    background: var(--login-surface);
  }
  .caixas-directory {
    position: relative;
    min-width: 0;
    border-top: 1px solid var(--login-border);
    border-bottom: 1px solid var(--login-border);
    background: var(--login-surface);
  }
  .caixas-directory-toolbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: .75rem;
    padding: .75rem 0;
    background: var(--login-surface);
  }
  .caixas-directory-toolbar .operational-search-field { max-width: 100%; }
  .caixas-supplier-head,
  .caixas-supplier-card-main {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(8rem, .65fr) 8rem 2.75rem;
    align-items: center;
    gap: clamp(.75rem, 2.5vw, 1.5rem);
  }
  .caixas-supplier-head {
    min-height: 2.5rem;
    padding: 0 var(--operational-row-inset);
    border-bottom: 1px solid var(--login-border);
    color: var(--login-muted);
    background: #f5f8f7;
    font: 700 .6875rem 'DM Sans', sans-serif;
    letter-spacing: .04em;
    text-transform: uppercase;
  }
  :root[data-theme='dark'] .caixas-supplier-head { background: #282a29; }
  .caixas-supplier-head span:nth-child(3) { text-align: right; }
  .caixas-supplier-list { display: grid; }
  .caixas-supplier-card {
    width: 100%;
    min-width: 0;
    min-height: 4.5rem;
    padding: .65rem var(--operational-row-inset);
    border: 0;
    border-bottom: 1px solid var(--login-border);
    color: inherit;
    background: transparent;
    cursor: pointer;
    text-align: left;
    transition: background var(--operational-motion-hover) ease;
  }
  .caixas-supplier-card:last-child { border-bottom: 0; }
  .caixas-supplier-card:hover { background: color-mix(in srgb, var(--login-accent) 8%, var(--login-surface)); }
  .caixas-supplier-card-copy { min-width: 0; }
  .caixas-supplier-name {
    display: block;
    color: var(--login-text);
    font-size: .94rem;
    font-weight: 700;
    overflow-wrap: anywhere;
  }
  .caixas-supplier-last {
    min-width: 0;
    color: var(--login-muted);
    font-size: .78rem;
    overflow-wrap: anywhere;
  }
  .caixas-supplier-balance {
    justify-self: end;
    color: var(--login-text);
    font: 700 1rem 'DM Mono', monospace;
    white-space: nowrap;
  }
  .caixas-supplier-open-chevron {
    width: 2.25rem;
    height: 2.25rem;
    display: grid;
    place-items: center;
    justify-self: end;
    color: var(--login-muted);
    transition: color var(--operational-motion-hover) ease, transform var(--operational-motion-hover) ease;
  }
  .caixas-supplier-card:hover .caixas-supplier-open-chevron { color: var(--login-accent); transform: translateX(2px); }
  .caixas-history { min-width: 0; }
  .caixas-shell nav[aria-label='Breadcrumb'] button:focus-visible { outline: 2px solid var(--login-accent); outline-offset: 2px; border-radius: 6px; }
  .caixas-history-identity {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto auto;
    align-items: center;
    gap: .75rem;
    min-height: 4.5rem;
    padding-bottom: .75rem;
    border-bottom: 1px solid var(--login-border);
  }
  .caixas-history-copy { min-width: 0; }
  .caixas-history-copy span {
    display: block;
    margin-bottom: .2rem;
    color: var(--login-muted);
    font: 700 .6875rem 'DM Sans', sans-serif;
    letter-spacing: .04em;
    text-transform: uppercase;
  }
  .caixas-history-copy h2 {
    margin: 0;
    color: var(--login-text);
    font: 700 clamp(1.25rem, 3vw, 1.55rem)/1.15 'Barlow Condensed', sans-serif;
    overflow-wrap: anywhere;
  }
  .caixas-balance-summary { min-width: 7.5rem; display: flex; flex-direction: column; align-items: flex-end; gap: .4rem; padding-left: .75rem; border-left: 2px solid var(--login-accent); text-align: right; }
  .caixas-balance-summary-label { color: var(--login-muted); font: 600 .7rem 'Barlow Condensed', sans-serif; letter-spacing: .06em; text-transform: uppercase; }
  .caixas-balance-summary-value { margin-top: 0; font: 700 1.25rem 'DM Mono', monospace; white-space: nowrap; }
  .caixas-toolbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: .5rem;
    padding: .75rem 0;
  }
  .caixas-search-wrap { position: relative; display: flex; min-width: 0; align-items: center; }
  .caixas-search-input {
    width: 100%;
    min-width: 0;
    min-height: 44px;
    padding-left: 2.55rem;
    padding-right: 2.75rem;
    border: 1px solid var(--login-border);
    border-radius: 10px;
    background: var(--login-bg);
    color: var(--login-text) !important;
    -webkit-text-fill-color: var(--login-text) !important;
    caret-color: var(--login-text) !important;
    font-size: .88rem;
  }
  .caixas-search-input::placeholder {
    color: var(--login-muted) !important;
    -webkit-text-fill-color: var(--login-muted) !important;
    opacity: 1;
  }
  .caixas-search-input:focus-visible { outline: 2px solid var(--login-accent); outline-offset: 2px; }
  .caixas-icon-button {
    width: 2.75rem;
    height: 2.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    border: 1px solid var(--login-border);
    border-radius: 10px;
    color: var(--login-muted);
    background: var(--login-surface);
    cursor: pointer;
    transition: background-color var(--operational-motion-hover) ease, color var(--operational-motion-hover) ease;
  }
  .caixas-toolbar-actions { display: flex; align-items: center; gap: .5rem; }
  .caixas-actions { display: flex; gap: .5rem; }
  .caixas-ledger-shell {
    position: relative;
    min-width: 0;
    border-top: 1px solid var(--login-border);
    border-bottom: 1px solid var(--login-border);
    background: var(--login-surface);
  }
  .caixas-ledger-shell::before,
  .caixas-directory::before {
    position: absolute;
    z-index: 3;
    top: -1px;
    left: 0;
    width: 34%;
    height: 2px;
    content: '';
    background: linear-gradient(90deg, transparent, var(--login-accent), transparent);
    opacity: 0;
    transform: translateX(-100%);
    pointer-events: none;
  }
  .caixas-ledger-shell[aria-busy='true']::before,
  .caixas-directory[aria-busy='true']::before { opacity: 1; animation: caixas-update-line 1.25s ease-in-out infinite; }
  @keyframes caixas-update-line { to { transform: translateX(294%); } }
  .caixas-ledger-table {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    color: var(--login-text) !important;
  }
  .caixas-ledger-table table { border-collapse: collapse; }
  .caixas-ledger-table thead th {
    min-height: 2.5rem;
    padding-top: .7rem;
    padding-bottom: .7rem;
    color: var(--login-muted);
    background: #f5f8f7;
    font: 700 .6875rem 'DM Sans', sans-serif;
    letter-spacing: .04em;
    text-transform: uppercase;
  }
  :root[data-theme='dark'] .caixas-ledger-table thead th { background: #282a29; }
  .caixas-ledger-table tbody td { border-color: var(--login-border); color: var(--login-text); box-shadow: none; }
  .caixas-observation-row { cursor: pointer; }
  .caixas-observation-row:hover { background: color-mix(in srgb, var(--login-accent) 4%, var(--login-surface)); }
  .caixas-row-detail-cell { display: flex; min-height: 2.25rem; align-items: center; justify-content: flex-end; }
  .caixas-observation-toggle {
    width: 2.75rem;
    height: 2.75rem;
    display: grid;
    place-items: center;
    border: 0;
    border-radius: 10px;
    color: var(--login-muted);
    background: transparent;
    cursor: pointer;
  }
  .caixas-disclosure-chevron { transition: transform var(--operational-motion-hover) ease; }
  [data-state='open'] .caixas-disclosure-chevron { transform: rotate(180deg); }
  .caixas-expanded-note { padding: .8rem .25rem; color: var(--login-text); }
  .caixas-detail-grid { display: grid; grid-template-columns: minmax(0, 1fr) auto auto; align-items: center; gap: clamp(1rem, 4vw, 3rem); }
  .caixas-detail-observation { min-width: 0; }
  .caixas-detail-observation strong,
  .caixas-balance-fact small { display: block; color: var(--login-muted); font: 700 .6875rem 'DM Sans', sans-serif; letter-spacing: .04em; text-transform: uppercase; }
  .caixas-detail-observation p { margin: .25rem 0 0; white-space: pre-wrap; overflow-wrap: anywhere; font-size: .84rem; line-height: 1.5; }
  .caixas-balance-comparison { display: grid; grid-template-columns: repeat(2, minmax(4.75rem, 1fr)); gap: 1.5rem; }
  .caixas-balance-fact { display: grid; justify-items: center; gap: .2rem; text-align: center; }
  .caixas-balance-fact strong { color: var(--login-muted); font: 700 1rem 'DM Mono', monospace; white-space: nowrap; }
  .caixas-balance-fact:last-child strong { color: var(--login-accent); }
  .caixas-table-action {
    min-height: 2.75rem;
    padding: 0 .65rem;
    color: var(--login-accent);
    border-color: color-mix(in srgb, var(--login-accent) 25%, var(--login-border));
    background: color-mix(in srgb, var(--login-accent) 7%, transparent);
    text-decoration: none;
    white-space: nowrap;
  }
  .caixas-table-action:hover:not(:disabled) {
    background: color-mix(in srgb, var(--login-accent) 10%, var(--login-surface));
    border-color: color-mix(in srgb, var(--login-accent) 35%, var(--login-border));
    text-decoration: none;
  }
  .caixas-carga-card { display: flex; align-items: center; justify-content: flex-end; }
  .caixas-carga-label { color: var(--login-muted); font-size: .78rem; }
  .caixas-mobile-row { min-width: 0; border-bottom: 1px solid var(--login-border); background: var(--login-surface); }
  .caixas-mobile-row-button { color: inherit; }
  .caixas-mobile-row-details { border-left: 2px solid var(--login-accent); background: color-mix(in srgb, var(--login-muted) 4%, var(--login-surface)); }
  .caixas-empty-state,
  .caixas-supplier-list-state {
    min-height: 18rem;
    display: grid;
    place-items: center;
    padding: 2rem 1rem;
    color: var(--login-muted);
    text-align: center;
  }
  .caixas-history-skeleton { border-top: 1px solid var(--login-border); border-bottom: 1px solid var(--login-border); background: var(--login-surface); }
  .caixas-skeleton-toolbar { min-height: 4.25rem; display: grid; grid-template-columns: minmax(0, 1fr) 7rem; align-items: center; gap: 1rem; padding: .75rem 0; border-bottom: 1px solid var(--login-border); background: var(--login-bg); }
  .caixas-skeleton-row { min-height: 4.4rem; display: grid; grid-template-columns: 1.2fr .55fr .65fr .85fr .7fr 2rem; align-items: center; gap: 1rem; padding: .65rem var(--operational-row-inset); border-bottom: 1px solid var(--login-border); }
  .caixas-skeleton-row:last-child { border-bottom: 0; }
  .caixas-skeleton-line { height: .85rem; border-radius: 3px; background: linear-gradient(90deg, color-mix(in srgb, var(--login-muted) 8%, var(--login-surface)), color-mix(in srgb, var(--login-muted) 18%, var(--login-surface)), color-mix(in srgb, var(--login-muted) 8%, var(--login-surface))); background-size: 200% 100%; animation: caixas-shimmer 1.4s linear infinite; }
  @keyframes caixas-shimmer { to { background-position: -200% 0; } }
  .caixas-pager { padding-right: .75rem !important; padding-left: .75rem !important; }
  .caixas-filter-input { color: var(--login-text) !important; -webkit-text-fill-color: var(--login-text) !important; background: var(--login-surface) !important; border-radius: 10px !important; }
  .caixas-filter-overlay {
    --login-bg: var(--caixas-dialog-surface);
    --login-surface: var(--caixas-dialog-surface);
    --login-border: var(--caixas-dialog-border);
    --login-text: var(--caixas-dialog-ink);
    --login-muted: var(--caixas-dialog-muted);
    align-items: center !important;
    padding: 1rem !important;
  }
  .caixas-filter-overlay[aria-labelledby='caixas-filter-title'] {
    align-items: flex-start !important;
    justify-content: flex-end !important;
    padding: 132px max(20px, calc((100vw - 1340px) / 2)) 16px 20px !important;
    background: transparent !important;
    backdrop-filter: none !important;
  }
  .caixas-filter-panel { width: min(100%, 470px) !important; border: 1px solid var(--login-border) !important; border-radius: 14px !important; box-shadow: 0 12px 32px rgb(0 0 0 / 12%) !important; }
  @media (min-width: 768px) {
    .caixas-filter-overlay[aria-labelledby='caixas-filter-title'] .caixas-filter-panel { max-height: calc(100dvh - 148px) !important; }
  }
  .caixas-filter-panel button[aria-label='Fechar filtros de caixas'] { border: 0 !important; border-radius: 10px !important; background: transparent !important; color: var(--login-muted) !important; }
  .caixas-filter-panel button[aria-label='Fechar filtros de caixas']:hover { background: color-mix(in srgb, #b83232 10%, var(--login-surface)) !important; color: #b83232 !important; }
  :root[data-theme='dark'] .caixas-filter-panel button[aria-label='Fechar filtros de caixas']:hover { color: #f19b89 !important; }

  :root:has(.caixas-shell) .supplier-box-overlay {
    --login-bg: var(--caixas-dialog-surface);
    --login-surface: var(--caixas-dialog-surface);
    --login-border: var(--caixas-dialog-border);
    --login-text: var(--caixas-dialog-ink);
    --login-muted: var(--caixas-dialog-muted);
    --login-accent: var(--caixas-primary);
    background: rgb(14 15 16 / 36%) !important;
  }
  :root[data-theme='dark']:has(.caixas-shell) .supplier-box-overlay { background: rgb(0 0 0 / 58%) !important; }
  :root:has(.caixas-shell) .supplier-box-panel {
    border: 1px solid var(--login-border) !important;
    border-radius: 20px !important;
    background: var(--login-surface) !important;
    box-shadow: 0 20px 56px rgb(0 0 0 / 16%) !important;
  }
  :root:has(.caixas-shell) .supplier-box-panel > div:first-child > div:first-child > div:first-child {
    color: var(--login-muted) !important;
    font: 700 .6875rem 'DM Sans', sans-serif !important;
    letter-spacing: .06em !important;
  }
  :root:has(.caixas-shell) .supplier-box-panel h2 {
    color: var(--login-text) !important;
    font: 700 1.4rem/1.2 'DM Sans', sans-serif !important;
    letter-spacing: -.03em !important;
  }
  :root:has(.caixas-shell) .supplier-box-close {
    border: 0 !important;
    border-radius: 10px !important;
    background: transparent !important;
    color: var(--login-muted) !important;
  }
  :root:has(.caixas-shell) .supplier-box-close:hover {
    background: color-mix(in srgb, #b83232 10%, var(--login-surface)) !important;
    color: #b83232 !important;
    transform: none !important;
  }
  :root[data-theme='dark']:has(.caixas-shell) .supplier-box-close:hover { color: #f19b89 !important; }
  :root:has(.caixas-shell) .supplier-box-close:focus-visible { outline: 2px solid var(--caixas-primary); outline-offset: 2px; }
  :root:has(.caixas-shell) .supplier-box-panel > div:nth-child(2) > div:first-child {
    gap: .45rem !important;
    padding-left: .9rem !important;
    border-left-width: 2px !important;
  }
  :root:has(.caixas-shell) .supplier-box-panel > div:nth-child(2) > div:first-child span:first-child {
    font: 700 .6875rem 'DM Sans', sans-serif !important;
    letter-spacing: .04em !important;
  }
  :root:has(.caixas-shell) .supplier-box-panel > div:nth-child(2) > div:first-child span:last-child {
    font: 700 1.25rem 'DM Mono', monospace !important;
    letter-spacing: 0 !important;
  }
  :root:has(.caixas-shell) .supplier-box-panel [role='radiogroup'] {
    gap: 4px !important;
    padding: 4px;
    border-color: var(--login-border) !important;
    border-radius: 12px !important;
    background: var(--login-bg);
  }
  :root:has(.caixas-shell) .supplier-box-choice {
    min-height: 44px;
    border: 0 !important;
    border-radius: 9px;
    background: transparent !important;
    color: var(--login-muted) !important;
    font: 700 .875rem 'DM Sans', sans-serif !important;
    letter-spacing: 0 !important;
  }
  :root:has(.caixas-shell) .supplier-box-choice:hover:not([aria-checked='true']) {
    background: color-mix(in srgb, var(--login-muted) 8%, var(--login-surface)) !important;
    color: var(--login-text) !important;
    transform: none !important;
  }
  :root:has(.caixas-shell) .supplier-box-choice[aria-checked='true'] { background: #eaf7ed !important; color: #183f3b !important; }
  :root:has(.caixas-shell) .supplier-box-choice:last-child[aria-checked='true'] { background: #fff0ef !important; color: #b83232 !important; }
  :root[data-theme='dark']:has(.caixas-shell) .supplier-box-choice[aria-checked='true'] { background: #282a29 !important; color: #8db47a !important; }
  :root[data-theme='dark']:has(.caixas-shell) .supplier-box-choice:last-child[aria-checked='true'] { background: #3b2929 !important; color: #f19b89 !important; }
  :root:has(.caixas-shell) .supplier-box-field {
    border: 1px solid var(--login-border) !important;
    border-radius: 10px !important;
    background: var(--login-surface) !important;
    color: var(--login-text) !important;
  }
  :root:has(.caixas-shell) .supplier-box-field:focus-visible { outline: 2px solid var(--caixas-primary); outline-offset: 2px; }
  :root:has(.caixas-shell) .supplier-box-footer-btn {
    min-height: 44px;
    border-radius: 12px !important;
    font: 700 .875rem 'DM Sans', sans-serif !important;
    letter-spacing: 0 !important;
  }
  :root:has(.caixas-shell) .supplier-box-footer-btn:first-child { border-color: var(--login-border) !important; background: var(--login-surface) !important; color: var(--login-text) !important; }
  :root:has(.caixas-shell) .supplier-box-footer-btn:last-child { border-color: var(--caixas-primary) !important; background: var(--caixas-primary) !important; color: #183f3b !important; }
  :root:has(.caixas-shell) .supplier-box-footer-btn:hover:not(:disabled) { transform: none !important; filter: brightness(1.03); }
  :root:has(.caixas-shell) .supplier-box-footer-btn:active:not(:disabled) { transform: scale(.98) !important; }
  :root:has(.caixas-shell) .supplier-box-footer-btn:focus-visible { outline: 2px solid var(--caixas-primary); outline-offset: 2px; }

  @media (max-width: 767px) {
    .caixas-shell { --app-page-gutter: 14px; padding: 16px var(--app-page-gutter) 72px; }
    .caixas-page-header { align-items: stretch; flex-direction: column; }
    .caixas-page-header-action,
    .caixas-page-header-action .caixas-pill-button { width: 100%; }
    .caixas-directory-toolbar { grid-template-columns: minmax(0, 1fr); gap: .4rem; padding: .65rem 0; }
    .caixas-supplier-head { display: none; }
    .caixas-supplier-card-main { grid-template-columns: minmax(0, 1fr) auto 1.75rem; gap: .6rem; }
    .caixas-supplier-last { display: none; }
    .caixas-supplier-card { min-height: 4.9rem; padding: .65rem var(--operational-row-inset); }
    .caixas-supplier-open-chevron { width: 1.75rem; height: 2.75rem; }
    .caixas-history-identity { grid-template-columns: minmax(0, 1fr); gap: .75rem; }
    .caixas-balance-summary { grid-column: 1 / -1; justify-self: stretch; flex-direction: row; align-items: baseline; justify-content: space-between; gap: .75rem; min-width: 0; padding: .75rem 0 0; border-left: 0; border-top: 1px solid var(--login-border); text-align: left; }
    .caixas-shell:has(.caixas-history) nav[aria-label='Breadcrumb'] { flex-wrap: wrap; }
    .caixas-history-identity > .caixas-pill-button { grid-column: 1 / -1; width: 100%; }
    .caixas-back-button { width: 2.75rem; padding: 0; }
    .caixas-balance-summary { min-width: 5.5rem; padding-left: .55rem; }
    .caixas-balance-summary-value { font-size: 1.25rem; }
    .caixas-toolbar { grid-template-columns: minmax(0, 1fr) auto; gap: .5rem; }
    .caixas-toolbar-actions { display: flex; grid-column: 2; justify-content: flex-end; }
    .caixas-toolbar-actions .caixas-pill-button { width: 44px; min-width: 44px; padding: 0; }
    .caixas-toolbar-actions .caixas-pill-button span { display: none; }
    .caixas-actions { grid-column: 1 / -1; justify-content: flex-end; }
    .caixas-ledger-table > div { overflow-x: clip !important; }
    .caixas-detail-grid { grid-template-columns: minmax(0, 1fr); align-items: start; gap: .75rem; }
    .caixas-balance-comparison { justify-content: start; gap: 1.5rem; }
    .caixas-balance-fact { justify-items: start; text-align: left; }
    .caixas-table-action { min-height: 2.75rem; }
    .caixas-skeleton-toolbar { grid-template-columns: minmax(0, 1fr); }
    .caixas-skeleton-toolbar .caixas-skeleton-line:last-child { display: none; }
    .caixas-skeleton-row { min-height: 4.9rem; grid-template-columns: minmax(0, 1fr) 5.5rem 1.5rem; gap: .6rem; padding: .65rem var(--operational-row-inset); }
    .caixas-skeleton-row .caixas-skeleton-line:nth-child(n + 4) { display: none; }
    .caixas-filter-overlay { align-items: flex-end !important; padding: 0 !important; }
    .caixas-filter-overlay[aria-labelledby='caixas-filter-title'] { align-items: flex-end !important; justify-content: center !important; padding: 0 !important; }
    .caixas-filter-panel { width: 100% !important; max-height: 92dvh !important; border-right: 0 !important; border-bottom: 0 !important; border-left: 0 !important; border-radius: 16px 16px 0 0 !important; }
    :root:has(.caixas-shell) .supplier-box-panel { border-radius: 20px 20px 0 0 !important; }
  }
  @media (max-width: 340px) {
    .caixas-toolbar-actions .caixas-pill-button { padding: 0 .5rem; font-size: .78rem; }
    .caixas-pager { padding-right: .15rem !important; padding-left: .15rem !important; }
  }
  @media (prefers-reduced-motion: reduce) {
    .caixas-page-stage,
    .caixas-pill-button,
    .caixas-table-action,
    .caixas-back-button,
    .caixas-icon-button,
    .caixas-disclosure-chevron,
    .caixas-supplier-open-chevron,
    .caixas-skeleton-line { animation: none !important; transition: none !important; transform: none !important; }
    .caixas-ledger-shell[aria-busy='true']::before,
    .caixas-directory[aria-busy='true']::before { animation: none !important; transform: none !important; }
  }
`;
